import { SideNavFooterLinks } from '../common/SideNavFooterLinks';

export const FallbackSideNavFooterLinks = () => <SideNavFooterLinks navItems={[]} />;
